/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM } from "@adapptio/lib-components";
import React, { FC } from "react";

export enum FIELD_ROW_TYPE {
	DEFAULT = "default",
	LIST = "list"
}

export interface IFieldRowProps extends React.ComponentPropsWithRef<"div"> {
	type?: FIELD_ROW_TYPE;
	className?: string;
}

export const FieldRow: FC<IFieldRowProps> = React.forwardRef(
	({ children, type, className, ...props }, ref) => {
		const baseClass = BEM("edt-field-row", null, {
			type: type
		});

		if (className) {
			baseClass.add(className);
		}

		return (
			<div className={baseClass.toClassName()} ref={ref} {...props}>
				{children}
			</div>
		);
	}
);
